import React from 'react'

import Icon, { IconNames } from 'components/icons'
import theme from 'components/theme'
import { isSameMonthAndYear } from 'helpers/dates'

import { IconContainer, NavBarContainer } from './styled'

const DatePickerNavbar = props => {
  const getColor = (first, second) => {
    if (isSameMonthAndYear(first, second)) {
      return theme.colors.grayLight
    }

    return theme.colors.blue
  }

  return (
    <NavBarContainer ref={props.datePickerNavbarRef}>
      <IconContainer onClick={() => props.onPreviousClick()} e2eClass={'previous-button'}>
        <Icon name={IconNames.ArrowLeft} color={getColor(props.fromMonth, props.month)} />
      </IconContainer>
      <IconContainer onClick={() => props.onNextClick()} e2eClass={'next-button'}>
        <Icon name={IconNames.ArrowRight} color={getColor(props.toMonth, props.month)} />
      </IconContainer>
    </NavBarContainer>
  )
}

export default DatePickerNavbar
